export type SavedParcelGeometryInput = {
  id: string
  geometry: Record<string, unknown>
  parcelExternalId?: string | null
}

function isPolygonGeometry(
  geometry: Record<string, unknown> | undefined,
): geometry is Record<string, unknown> & (GeoJSON.Polygon | GeoJSON.MultiPolygon) {
  const g = geometry as { type?: string; coordinates?: unknown } | undefined
  return (
    g != null &&
    (g.type === 'Polygon' || g.type === 'MultiPolygon') &&
    Array.isArray(g.coordinates) &&
    g.coordinates.length > 0
  )
}

export function buildParcelHighlightFeatureCollection(
  savedParcels: ReadonlyArray<SavedParcelGeometryInput>,
  robustIds: ReadonlyArray<string>,
): GeoJSON.FeatureCollection {
  const wanted = new Set(robustIds)
  return {
    type: 'FeatureCollection',
    features: savedParcels
      .filter(
        (parcel) =>
          parcel.parcelExternalId != null &&
          wanted.has(parcel.parcelExternalId) &&
          isPolygonGeometry(parcel.geometry),
      )
      .map((parcel) => ({
        type: 'Feature' as const,
        properties: { id: parcel.id, robust_id: parcel.parcelExternalId ?? null },
        geometry: parcel.geometry as unknown as GeoJSON.Polygon | GeoJSON.MultiPolygon,
      })),
  }
}
